import { GeneralContractor } from '@api/api';
import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const IdentityActions = createActionGroup({
  source: 'Identity',
  events: {
    'Fetch Identity': emptyProps(),
    'Fetch Identity Succeeded': props<{ account: any }>(),
    'Fetch Identity Failed': props<{ error }>(),
    'Fetch General Contractor Succeeded': props<{ generalContractor: GeneralContractor }>(),
    'Fetch General Contractor Failed': emptyProps(),
    'No ContractorNumber present in token': emptyProps(),
  },
});
